import { EN } from "./en";
import { IT } from "./it";
import { AR } from "./ar";


export default class Languages {

    static LANGUAGE_NAME = 'EN';

    static EN = {...EN};

    static IT = {...IT};

    static AR = {...AR};
}